export enum CreditRange {
  EXCELLENT = 'excellent',
  GOOD = 'good',
  AVERAGE = 'average',
  LOW = 'low',
}

export type CreditRangeOption = {
  name: string;
  shortName: string;
  value: CreditRange;
};

export enum AgeRange {
  AT_OR_OVER_25 = 'AT_OR_OVER_25',
  LESS_THAN_25 = 'LESS_THAN_25',
}

export const ageRangeOptions = [
  { name: '25+', value: AgeRange.AT_OR_OVER_25 },
  { name: '< 25', value: AgeRange.LESS_THAN_25 },
];

export const milesPerMonthOptions = [
  {
    name: '~200 miles per month (Occasional Driver)',
    value: '200',
  },
  {
    name: '~850 miles per month (Standard Commuter)',
    value: '850',
  },
  {
    name: '~1,200 miles per month (Extended Commuter)',
    value: '1200',
  },
  {
    name: '~2,000 miles per month (Road warrior)',
    value: '2000',
  },
];

export const ownershipYearsOptions = [
  {
    name: '1 year',
    value: '1',
  },
  {
    name: '3 years',
    value: '3',
  },
  {
    name: '5 years',
    value: '5',
  },
  {
    name: '6+ years',
    value: '6',
  },
];
